import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7761a819"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "evaluation" }
const _hoisted_2 = {
  key: 0,
  class: "title p-pb-2"
}
const _hoisted_3 = {
  key: 1,
  class: "title p-pb-2"
}
const _hoisted_4 = {
  key: 2,
  class: "evaluation-description"
}
const _hoisted_5 = {
  key: 3,
  class: "evaluation-description"
}
const _hoisted_6 = {
  key: 4,
  class: "evaluation-description"
}
const _hoisted_7 = { class: "p-mt-3" }
const _hoisted_8 = {
  key: 0,
  class: "student-corrections p-my-3"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_EvaluationItem = _resolveComponent("EvaluationItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isTutor)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.t('homework.challenge.peerReview.correction.tutor.title')), 1))
      : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.t('homework.challenge.peerReview.card.button.label')), 1)),
    (_ctx.isTutor && _ctx.usePeerReview)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.t('homework.challenge.peerReview.correction.tutor.subtitle')), 1))
      : (_ctx.isTutor && !_ctx.usePeerReview)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.t('homework.challenge.correction.tutor.subtitle')), 1))
        : (_ctx.usePeerReview)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.t('homework.challenge.peerReview.correction.student.subtitle')), 1))
          : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.evaluationCriteria, (item, index) => {
        return (_openBlock(), _createBlock(_component_EvaluationItem, {
          key: `section-${index}`,
          header: `${index + 1}. ${item.title}`,
          open: index === 0
        }, {
          default: _withCtx(() => [
            (_ctx.isTutor && _ctx.usePeerReview)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.studentsEvaluations, (criteria, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `stc-${index}`
                  }, [
                    (criteria.criteria === item.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(criteria.evaluations.slice(0,3), (evaluation, key) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: key,
                              class: "evaluation-description"
                            }, [
                              _createTextVNode(_toDisplayString(key + 1) + " " + _toDisplayString(_ctx.t('homework.challenge.peerReview.correction.student.label')) + ": ", 1),
                              _hoisted_9,
                              _createTextVNode(" " + _toDisplayString(_ctx.t(`homework.challenge.peerReview.correction.student.${evaluation}`)), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.evaluationCriteria, (option, indx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: indx,
                class: "option p-py-2"
              }, [
                _createVNode(_component_RadioButton, {
                  id: `${option.score}${index}`,
                  name: `criteria-${index}`,
                  value: option.score,
                  modelValue: _ctx.criteria[item.id],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.criteria[item.id]) = $event),
                  onChange: _ctx.selectCriteria
                }, null, 8, ["id", "name", "value", "modelValue", "onUpdate:modelValue", "onChange"]),
                _createElementVNode("label", {
                  for: `${option.score}${index}`
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(option.title), 1),
                    _createElementVNode("p", null, _toDisplayString(option.description), 1)
                  ])
                ], 8, _hoisted_10)
              ]))
            }), 128))
          ]),
          _: 2
        }, 1032, ["header", "open"]))
      }), 128))
    ])
  ]))
}